<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700">Marketplace</h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">Introducing QuickKicks Marketplace, where buyers will
              be<br/>able to buy the cheapest authenticated sneaker(s).</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1">
          <img alt="" class="img-fluid" src="/assets/images/about-shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <!-- about-us-detail -->
  <div class="container about-detail">
    <h2 class="oswald_font bold_500">Seller</h2>
    <div class="row services ">
      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_1.png">
          </div>
          <h4 class="title"><a href="">Ask</a></h4>
          <p class="description">List your sneaker(s) for sale at any price.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="100">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_2.png">
          </div>
          <h4 class="title"><a href="">Sell Now</a></h4>
          <p class="description">Sell your sneaker (s) at the highest bid.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="200">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_3.png">
          </div>
          <h4 class="title"><a href="">Shipping</a></h4>
          <p class="description">Package your sneaker (s) carefully, attach the prepaid label we provide
            and ship within business days</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="300">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_4.png">
          </div>
          <h4 class="title"><a href="">Authentication</a></h4>
          <p class="description">We authenticate your sneaker (s), then ship them to the buyer.</p>
        </div>
      </div>
    </div>
    <h2 class="oswald_font bold_500">buyer</h2>
    <div class="row services ">
      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_5.png">
          </div>
          <h4 class="title"><a href="">Bid</a></h4>
          <p class="description">Make a bid for a sneaker at any any price</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="100">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_6.png">
          </div>
          <h4 class="title"><a hrf="">Buy Now</a></h4>
          <p class="description">Buy s snesker now for the asking price</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="200">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_7.png">
          </div>
          <h4 class="title"><a href="">Shipping</a></h4>
          <p class="description">We package your sneaker(s) carefully, and ship them directly to you
            within 2 business days.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate"
           data-aos="fade-up" data-aos-delay="300">
        <div class="icon-box">
          <div class="icon-box-round">
            <img alt="images" src="/assets/images/About_8.png">
          </div>
          <h4 class="title"><a href="">Authentication</a></h4>
          <p class="description">We authenticate your sneaker(s), then ship them to the buyer.</p>
        </div>
      </div>
    </div>
    <div class="bottom_info">
      <div class="bottom_info-inner m-auto col-xl-9">
        <div class="about_inno">
          <div class="about_ino_main">
            <img alt="images" src="/assets/images/about_info.png">
          </div>
        </div>
        <p>
                        <span class="ture_icon"><img alt="images" class="white_ture" src="/assets/images/info-ture.png"><img
                          alt="images" class="dark_ture" src="/assets/images/dark_ture.png"></span>
          Introducing QuickKicks Marketplace, wherr buyers will be able the cheapest authenticated sneaker
          (s) and sellers will be able to sell their sneaker(s) for the highest payout.
        </p>
      </div>
    </div>
  </div>
</main>
